import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import * as _ from 'lodash-es';
import { VIEWMODE } from 'src/app/shared/pages/view/view.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FileUploaderComponent } from '../../file-uploader/file-uploader.component';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

export interface IFileUploadDialogOptions {
    title: string;
    text: string;
    view_mode: VIEWMODE;
    maxFileSize: number;
    fileFormats: string[];
    multiple: boolean | number;
    control: FormControl;
}


@Component({
    selector: 'app-file-upload-dialog',
    templateUrl: './file-upload-dialog.component.html',
    styleUrls: ['./file-upload-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FileUploaderComponent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class FileUploadDialog {
    dialogRef = inject<MatDialogRef<FileUploadDialog>>(MatDialogRef);
    data = inject<IFileUploadDialogOptions>(MAT_DIALOG_DATA);

    protected _defaultCtx: IFileUploadDialogOptions = {
        title: 'UPLOAD_FILE',
        text: 'PLEASE_UPLOAD_FILE',
        view_mode: VIEWMODE.EDIT,
        maxFileSize: 20000,
        fileFormats: [],
        multiple: false,
        control: new FormControl(),
    };

    public ctx: IFileUploadDialogOptions;

    constructor() {
        this.ctx = _.assign(this._defaultCtx, this.data);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
